module.exports = __webpack_public_path__ + "img/_Cement-Kiln-Graphic.455ba91e.gif";